module["exports"] = [
  "??# #??",
  "??## #??",
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_GB/address/postcode.js
// module id = 1015
// module chunks = 0